export function truncate(s, chars = 80, append = '…') {
    if(s.length <= chars) {
        return s;
    }
    return s.substring(0, chars).trim() + append;
}

export function formatAmount(amount) {
    let result = "";
    let amountString = String(amount);
    let pieces = amountString.split(".");
    let dollars = pieces[0];
    let digitsShown = 0;

    for (let i = dollars.length - 1; i >= 0; --i) {
        digitsShown = dollars.length - i;
        if ((digitsShown % 3 === 1) && (digitsShown > 1)) {
            result = "," + result;
        }
        result = dollars.charAt(i) + result;
    }

    if (pieces[1]) {
        result += "." + (pieces[1] + "00").slice(0, 2);
    }

    return result;
}


export default {
    truncate: truncate,
    formatAmount: formatAmount
};



// WEBPACK FOOTER //
// ./app/utils/string.js